import vars from '@softwaredev_cegeka/stix-core/styles/theme-vars-exports.module.scss'
import themeVars from 'src/assets/styles/stix/export-stix-theme-vars.module.scss'

const styles = {
    clearIndicator: provided => ({
        ...provided,
        color: vars.bodyColor,
        paddingRight: '0.625rem',
        '&:hover': {
            color: vars.primary,
        },
    }),

    control: (provided, state) => ({
        ...provided,
        borderRadius: '0.25rem',
        boxShadow: state.isFocused ? vars.inputFocusBoxShadow : 'none',
        fontWeight: vars.inputFontWeight,
        borderColor: state.isFocused
            ? vars.inputFocusBorderColor
            : vars.inputBorderColor,
        cursor: 'pointer',
        '&:hover': {
            borderColor: vars.inputFocusBorderColor,
            cursor: '1',
        },
        '&:active': {
            borderColor: vars.inputFocusBorderColor,
        },
        ...(state.isDisabled
            ? {
                  color: themeVars.inputDisabledColor,
                  backgroundColor: themeVars.inputDisabledBg,
              }
            : {}),
    }),

    dropdownIndicator: (provided, state) => {
        return {
            ...provided,
            color: state.isFocused ? vars.secondary : vars.bodyColor,
            // The padding is calculated like this because of the transform prop
            // which rotates the element resulting in paddingLeft becoming paddingRight
            // and paddingRight becoming paddingLeft when menu is open
            paddingLeft: state.selectProps.menuIsOpen ? '0.75rem' : '0.625rem',
            paddingRight: state.selectProps.menuIsOpen ? '0.625rem' : '0.75rem',
            transform: state.selectProps.menuIsOpen
                ? 'rotate(180deg)'
                : 'rotate(0)',
            '&:hover': {
                color: state.isFocused ? vars.secondary : vars.primary,
            },
        }
    },

    group: provided => ({
        ...provided,
        borderTop: `1px solid ${vars.dropdownBorderColor}`,
        '&:first-of-type': {
            borderTop: '0',
        },
    }),

    groupHeading: provided => ({
        ...provided,
        textTransform: 'uppercase',
        fontWeight: '600',
        fontSize: '.875rem',
        padding: '.5rem 1rem',
        marginBottom: '0',
    }),

    indicatorSeparator: (provided, state) => ({
        ...provided,
        display: state.hasValue ? 'block' : 'none',
    }),

    input: provided => ({
        ...provided,
        marginLeft: 0,
        marginRight: 0,
    }),

    loadingMessage: provided => ({
        ...provided,
        color: vars.bodyColor,
    }),

    menu: provided => ({
        ...provided,
        margin: '0.5rem 0 0',
        border: `1px solid ${vars.dropdownBorderColor}`,
        zIndex: vars.zIndexDropdown,
        boxShadow: vars.elevationLevel4,
    }),

    menuList: provided => ({
        ...provided,
        padding: '0.5rem 0',
        margin: '0.125rem 0 0',
    }),

    multiValueRemove: provided => ({
        ...provided,

        '&:hover': {
            backgroundColor: 'transparent',
        },
    }),

    noOptionsMessage: provided => ({
        ...provided,
        color: vars.bodyColor,
    }),

    option: (provided, state) => ({
        ...provided,
        fontSize: vars.dropdownFontSize,
        color: state.isSelected ? vars.secondary : vars.primary,
        fontWeight: state.isSelected ? 600 : 400,
        backgroundColor:
            state.isSelected || state.isFocused
                ? vars.reactSelectSelectedOptionBg
                : 'inherit',
        padding: `0.25rem ${vars.dropdownItemPaddingX}`,
        '&:hover': {
            color: vars.dropdownLinkHoverColor,
            backgroundColor: vars.reactSelectSelectedOptionBg,
        },
    }),

    placeholder: provided => ({
        ...provided,
        color: themeVars.inputPlaceholderColor,
        fontSize: vars.inputBtnFontSize,
        fontWeight: vars.inputPlaceholderFontWeight,
        marginLeft: 0,
        marginRight: 0,
    }),

    singleValue: (provided, state) => ({
        ...provided,
        color: vars.inputColor,
        fontSize: vars.inputBtnFontSize,
        marginLeft: 0,
        marginRight: 0,
        ...(state.isDisabled ? { color: themeVars.inputDisabledColor } : {}),
    }),

    valueContainer: provided => ({
        ...provided,
        paddingLeft: '0.75rem',
        paddingRight: '0.75rem',
    }),
}

export default styles
